import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '美立方 - 一个汇聚美的地方' },
    component: HomeView
  },
  {
    path: '/introduce',
    name: 'Introduce',
    meta: { title: '美立方 - 美立方简介' },
    component: () => import('@/views/introduce'),
    redirect: '/introduce/advantage',
    children: [
      {
        name: 'Advantage',
        path: '/introduce/advantage',
        meta: { title: '美立方 - 美立方简介' },
        component: () => import('@/views/introduce/advantage'),
      },
      {
        name: 'Postion',
        path: '/introduce/position',
        meta: { title: '美立方 - 创新定位' },
        component: () => import('@/views/introduce/position'),
      },
      {
        name: 'Layout',
        path: '/introduce/layout',
        meta: { title: '美立方 - 业态布局' },
        component: () => import('@/views/introduce/layout'),
      },
      {
        name: 'Manage',
        path: '/introduce/manage',
        meta: { title: '美立方 - 主力客群' },
        component: () => import('@/views/introduce/manage'),
      },
      {
        name: 'Pictures',
        path: '/introduce/pictures',
        meta: { title: '美立方 - 效果图集' },
        component: () => import('@/views/introduce/pictures'),
      }
    ]
  },
  {
    path: '/cooperate',
    name: 'Cooperate',
    meta: { title: '美立方 - 招商合作' },
    component: () => import('@/views/cooperate'),
  },
  {
    path: '/news',
    name: 'News',
    meta: { title: '美立方 - 新闻中心' },
    component: () => import('@/views/news'),
    redirect: '/news/news',
    children: [
      {
        name: 'news',
        path: '/news/news',
        meta: { title: '美立方 - 新闻中心' },
        component: () => import('@/views/news/news'),
      },
      // {
      //   name: 'Contact',
      //   path: '/about/contact',
      //   component: () => import('@/views/about/contact'),
      // },
      // {
      //   name: 'Arrive',
      //   path: '/about/arrive',
      //   component: () => import('@/views/about/arrive'),
      // }
    ]
  },
  {
    path: '/search',
    name: 'Search',
    meta: { title: '' },
    component: () => import('@/views/news/search'),
  },
  {
    path: '/news/detail',
    name: 'Detail',
    meta: { title: '' },
    component: () => import('@/views/news/detail'),
  },
  {
    path: '/show',
    name: 'Show',
    meta: { title: '美立方 - 商户展示' },
    component: () => import('@/views/show'),
    redirect: '/show/merchant',
    children: [
      {
        name: 'news',
        path: '/show/merchant',
        meta: { title: '美立方 - 商户展示' },
        component: () => import('@/views/show/merchant'),
      },
      // {
      //   name: 'Contact',
      //   path: '/about/contact',
      //   component: () => import('@/views/about/contact'),
      // },
      // {
      //   name: 'Arrive',
      //   path: '/about/arrive',
      //   component: () => import('@/views/about/arrive'),
      // }
    ]
  },
  {
    path: '/about',
    name: 'About',
    meta: { title: '' },
    component: () => import('@/views/about'),
    redirect: '/about/contact',
    children: [
      // {
      //   name: 'Summary',
      //   path: '/about/contact',
      //   component: () => import('@/views/about/contact'),
      // },
      {
        name: 'Contact',
        path: '/about/contact',
        meta: { title: '美立方 - 联系我们' },
        component: () => import('@/views/about/contact'),
      },
      {
        name: 'Arrive',
        path: '/about/arrive',
        meta: { title: '美立方 - 到达方式' },
        component: () => import('@/views/about/arrive'),
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    // return {x:0,y:0};
  },
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next() 
})

router.afterEach((to, from) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
